import axios from 'axios';

const wmsApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: { 'Content-Type': 'application/json' },
});
wmsApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

export const getWmsClientes = async () => {
  const res = await wmsApi.get('/api/v1/wms/clientes');
  return res.data;
};
export const createWmsCliente = async (data) => {
  const res = await wmsApi.post('/api/v1/wms/clientes/', data);
  return res.data;
};
export const updateWmsCliente = async (id, data) => {
  const res = await wmsApi.put(`/api/v1/wms/clientes/${id}`, data);
  return res.data;
};
export const deleteWmsCliente = async (id) => {
  const res = await wmsApi.delete(`/api/v1/wms/clientes/${id}`);
  return res.data;
};
